// extracted by mini-css-extract-plugin
export default {"limitWrapper":"RichTextEditor_limitWrapper__hX5s8","wrapper":"RichTextEditor_wrapper__sCPzv","limit":"RichTextEditor_limit__fBl6P"};